export default {
  root: {
    height: '50px',
    fontWeight: 400,
    textTransform: 'none',
    fontSize: '14px',
    '@media (min-width: 960px)': {
      minWidth: '100px',
    },
    '&$selected': {
      fontWeight: 500,
    },
  },
  label: {},
  // Removed labelContainer and textColorPrimary as they're not valid MUI Tab style keys
  // They were causing the prop warnings
};
